var map = {
	"./01_Stella.png": 9642,
	"./02_Pausa.png": 7135,
	"./03_Lazzarin.png": 7472,
	"./04_Per.png": 5145,
	"./05_Lazzaris.png": 8273,
	"./06_CadelPoggio.png": 9046,
	"./07_TopBanqueting.png": 9430,
	"./08_Cuzziol.png": 8667,
	"./09_Ferrarelle.png": 6536,
	"./10_Bav.png": 6661,
	"./11_Martini.png": 3776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1257;